/**
 * VDB Global Scripts
 * Extracted from layout/theme.liquid to improve FCP, TTI, and parse times.
 */

// 0. Capture ad click IDs & UTM and persist
(function () {
  var qs = new URLSearchParams(window.location.search);
  var keys = ['gclid','gbraid','wbraid','dclid','msclkid','fbclid','ttclid',
              'utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  var changed = false;

  function setCookie(n, v, days){
    var d = new Date(); d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = n + '=' + encodeURIComponent(v) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  keys.forEach(function(k){
    var val = qs.get(k);
    if (val) {
      localStorage.setItem('shopify_' + k, val);
      setCookie('shopify_' + k, val, 90);
      changed = true;
    }
  });
})();

// 1. Attach gclid to Shopify cart attributes
// Optimization: We could run this only on cart:added, but leaving on DOMContentLoaded for parity.
document.addEventListener('DOMContentLoaded', function() {
  var gclid = localStorage.getItem('shopify_gclid');
  if (gclid) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { gclid: gclid } })
        });
      });
  }
});

// 2. Cart Hold Timer — Engine (global)
(function(){
  if (window.CartHoldTimer) return;

  function cartId(){ var m=document.cookie.match(/(?:^|;)\s*cart=([^;]+)/); return m?decodeURIComponent(m[1]):'site'; }
  function kEnd(){ return 'ct_end_'+cartId(); }
  function kRst(){ return 'ct_rst_'+cartId(); }
  function lsGet(k){ try{ return localStorage.getItem(k) }catch(e){ return null } }
  function lsSet(k,v){ try{ localStorage.setItem(k,v) }catch(e){} }
  function lsDel(k){ try{ localStorage.removeItem(k) }catch(e){} }

  var DUR_MS = 25*60*1000;           // 25 minutes
  var EXT_MS = 5*60*1000;            // 5 minutes

  function now(){ return Date.now(); }
  function setEnd(ms){ var ts=now()+ms; lsSet(kEnd(), String(ts)); return ts; }
  function getEnd(){ var v=parseInt(lsGet(kEnd())||'0',10); return isNaN(v)?0:v; }

  window.CartHoldTimer = {
    get end(){ return getEnd(); },
    start: function(){ if(!getEnd() || getEnd()<=now()) setEnd(DUR_MS); dispatch('cart_timer_started'); },
    resetFull: function(){ setEnd(DUR_MS); dispatch('cart_timer_reset'); },
    extend: function(ms){ var e=Math.max(getEnd(), now()+ms); lsSet(kEnd(), String(e)); dispatch('cart_timer_extended'); },
    expire: function(){ lsSet(kEnd(), String(now())); dispatch('cart_timer_expired'); },
    markRestartUsed: function(){ lsSet(kRst(),'1'); },
    restartUsed: function(){ return lsGet(kRst())==='1'; },
    clear: function(){ lsDel(kEnd()); lsDel(kRst()); dispatch('cart_timer_cleared'); },
    DUR_MS: DUR_MS, EXT_MS: EXT_MS
  };

  function dispatch(name, detail){ try{ window.dispatchEvent(new CustomEvent(name,{detail})) }catch(_){} }

  window.CartHoldTimer.start();

  (function(){
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input==='string')? input : (input&&input.url)||'';
      var isAdd = /\/cart\/add(?:\.js)?/.test(url || '');
      return _fetch.apply(this, arguments).then(function(res){
        if(isAdd && res && res.ok){ window.CartHoldTimer.resetFull(); }
        return res;
      });
    };
    var open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m,u){ this.__isAdd = /\/cart\/add(?:\.js)?/.test(u||''); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function(){
      this.addEventListener('load', ()=>{ if(this.__isAdd && this.status>=200 && this.status<300) window.CartHoldTimer.resetFull(); });
      return send.apply(this, arguments);
    };
  })();

  document.addEventListener('cart:updated', function(e){
    var n = e?.detail?.item_count;
    if(n===0) window.CartHoldTimer.clear();
  });
})();

// 3. Cart Sidebar Auto Close — single observer with interaction awareness
document.addEventListener("DOMContentLoaded", function() {
  const cartSidebar = document.querySelector('#site-cart-sidebar');
  if (!cartSidebar) return;

  let autoCloseTimer = null;
  const autoCloseDelay = 3000;

  function closeCart() {
    const closeButton = cartSidebar.querySelector('[data-js-close]');
    if (closeButton) {
      closeButton.click();
    } else {
      cartSidebar.classList.remove('sidebar--opened');
    }
    autoCloseTimer = null;
  }

  function startAutoCloseTimer() {
    clearAutoCloseTimer();
    autoCloseTimer = setTimeout(closeCart, autoCloseDelay);
  }

  function clearAutoCloseTimer() {
    if (autoCloseTimer) {
      clearTimeout(autoCloseTimer);
      autoCloseTimer = null;
    }
  }

  // Watch for sidebar open/close via class changes
  new MutationObserver(function() {
    if (cartSidebar.classList.contains('sidebar--opened')) {
      startAutoCloseTimer();
    } else {
      clearAutoCloseTimer();
    }
  }).observe(cartSidebar, { attributes: true, attributeFilter: ['class'] });

  // Pause timer while user interacts
  ['mouseenter', 'touchstart', 'focusin'].forEach(function(event) {
    cartSidebar.addEventListener(event, clearAutoCloseTimer);
  });

  // Resume timer when user stops interacting
  ['mouseleave', 'touchend', 'focusout'].forEach(function(event) {
    cartSidebar.addEventListener(event, function() {
      if (cartSidebar.classList.contains('sidebar--opened')) {
        startAutoCloseTimer();
      }
    });
  });
});

// 5. Product Description Toggle Logic
window.addEventListener('load', function () {
  const desc = document.getElementById('product-description');
  if(!desc) return;

  const toggleBtn = document.getElementById('toggle-description');
  const hasHeadings = desc.querySelector('h2, h3');
  const productTitle = document.querySelector('h1.product__title')?.textContent?.trim() || '';

  if (!hasHeadings) {
    const label = (window.Shopify && window.Shopify.locale === 'it') ? 'Descrizione del prodotto' : 'Description of';
    const h2 = document.createElement('h2');
    h2.textContent = `${label} ${productTitle}`;
    h2.classList.add('injected-heading');
    desc.prepend(h2);

    desc.classList.add('description-truncated');

    if (toggleBtn) {
      toggleBtn.style.display = 'inline-flex';
      toggleBtn.innerHTML = (window.Shopify && window.Shopify.locale === 'it') ? 'Mostra di più ⌄' : 'Show More ⌄';

      toggleBtn.addEventListener('click', function () {
        desc.classList.toggle('expanded');
        const isExpanded = desc.classList.contains('expanded');
        toggleBtn.innerHTML = isExpanded
          ? ((window.Shopify && window.Shopify.locale === 'it') ? 'Mostra meno ⌃' : 'Show Less ⌃')
          : ((window.Shopify && window.Shopify.locale === 'it') ? 'Mostra di più ⌄' : 'Show More ⌄');
      });
    }

  } else {
    if(toggleBtn) toggleBtn.style.display = 'none';
    desc.classList.remove('description-truncated');

    const headings = desc.querySelectorAll('h2, h3');
    headings.forEach(function (heading, i) {
      const contentWrapper = document.createElement('div');
      contentWrapper.className = 'toggle-section-content';

      let sibling = heading.nextElementSibling;
      while (sibling && !['H2', 'H3'].includes(sibling.tagName)) {
        const next = sibling.nextElementSibling;
        contentWrapper.appendChild(sibling);
        sibling = next;
      }

      heading.after(contentWrapper);
      heading.classList.add('toggle-section-heading');

      if (i === 0) {
        contentWrapper.classList.add('expanded', 'first-expanded');
        heading.classList.add('first-heading-expanded');
      }

      heading.addEventListener('click', function () {
        const isFirst = i === 0;

        contentWrapper.classList.toggle('expanded');
        heading.classList.toggle('expanded');

        if (isFirst) {
          contentWrapper.classList.toggle('first-expanded');
        }
      });
    });
  }
});

// 6. Clickable Badge Delegation
(function(){
  function go(e, el){ e.preventDefault(); e.stopImmediatePropagation(); window.location.href = el.dataset.url; }
  document.addEventListener('click', function(e){
    const el = e.target.closest('.clickable-badge');
    if (el) go(e, el);
  }, true); 
  document.addEventListener('keydown', function(e){
    if((e.key==='Enter'||e.key===' ') && e.target.classList && e.target.classList.contains('clickable-badge')){
      go(e, e.target);
    }
  }, true);
})();
